// The Field "can this response be started now?" rule, offline half (card #4152).
//
// Mirrors Response#start_block_reason / #startable_now? (app/models/response.rb).
// Both are checked against test/fixtures/files/field_start_rule_cases.json so
// they cannot drift. A response is startable when its status is "scheduled" and
// its schedule date, read in the Tasker's time zone, is today or earlier.
//
// Offline the cache has no mission status, so mission-live is not checked here:
// the server stays the authority for that.

const ZONE_KEY = "field:time-zone"

// The Tasker's IANA zone, remembered whenever an online page renders
// (field_time_zone_controller.js). Falls back to the device zone.
export function rememberedTimeZone() {
  try {
    const saved = localStorage.getItem(ZONE_KEY)
    if (saved && isValidZone(saved)) return saved
  } catch (_error) { /* storage blocked */ }
  return Intl.DateTimeFormat().resolvedOptions().timeZone
}

export function rememberTimeZone(zone) {
  if (!zone || !isValidZone(zone)) return
  try { localStorage.setItem(ZONE_KEY, zone) } catch (_error) { /* storage blocked */ }
}

function isValidZone(zone) {
  try {
    new Intl.DateTimeFormat("en-AU", { timeZone: zone })
    return true
  } catch (_error) {
    return false
  }
}

// "YYYY-MM-DD" for an instant, read in `timeZone`.
export function localDay(instant, timeZone) {
  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone, year: "numeric", month: "2-digit", day: "2-digit"
  }).formatToParts(new Date(instant))
  const get = (type) => parts.find((part) => part.type === type).value
  return `${get("year")}-${get("month")}-${get("day")}`
}

// null when Start is available, else "unscheduled", "future" or "not_startable".
export function startBlockReason(record, { now = new Date(), timeZone = rememberedTimeZone() } = {}) {
  if (record.status === "todo") return "unscheduled"
  if (record.status !== "scheduled") return "not_startable"
  if (!record.scheduledAt || Number.isNaN(Date.parse(record.scheduledAt))) return "unscheduled"

  if (localDay(record.scheduledAt, timeZone) > localDay(now, timeZone)) return "future"
  return null
}

export function startableNow(record, options) {
  return startBlockReason(record, options) === null
}

// A started response is continued; a scheduled one can be opened only when due.
export function canOpenSurvey(record, options) {
  return record.status === "started" || startableNow(record, options)
}
